import { normalizeString } from 'helpers/stringUtils';
import { DefaultOptionType } from 'antd/lib/select';

/**
 * Helper function for filtering options in Select components
 * Normalizes both the input and option text for case-insensitive and accent-insensitive comparison
 *
 * @param input - The search input string
 * @param option - The option object from the Select component
 * @returns boolean indicating if the option matches the input
 */
export default function filterOptionByNormalizedString(
  input: string,
  option: DefaultOptionType | undefined
): boolean {
  const normalizedInput = normalizeString(input);
  if (!option) return false;

  // option.children can be a React node (e.g. PersonOptionLabel showing the
  // license line), so match against the first field that is actually a string
  // — the plain `label`/`value` — instead of normalizing a React element,
  // which would throw "str.normalize is not a function".
  const optionText = [option.children, option.label, option.value].find(
    (candidate): candidate is string =>
      typeof candidate === 'string' && candidate.length > 0
  );
  if (!optionText) return false;
  const normalizedOptionText = normalizeString(optionText);

  return Boolean(normalizedOptionText.includes(normalizedInput));
}
